(() => {
  if (customElements.get('scroll-to')) {
    return;
  }

  class ScrollTo extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.attachEvents();
    }

    attachEvents() {
      this.addEventListener('click', this.scrollTo.bind(this));
    }

    scrollTo(event) {
      const element = document.querySelector(this.dataset.elementId);

      if (!element) {
        return;
      }

      if (this.dataset.elementId === '#pdp-specification') {
        element.querySelector('summary')?.click();

        event.preventDefault();

        return;
      }

      const announcementBar = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--topbar-height'), 0);
      const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 0);
      const stickyHeaderHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--sticky-header-height'), 0);
      const finalHeaderHeight = stickyHeaderHeight ? stickyHeaderHeight : headerHeight;

      window.scrollTo({
        top: element.getBoundingClientRect().top + window.scrollY - (finalHeaderHeight + announcementBar),
        behavior: theme.config.motionReduced ? 'auto' : 'smooth'
      });

      event.preventDefault();
    }
  }

  customElements.define('scroll-to', ScrollTo);
})();

(() => {
  if (customElements.get('scroll-to-specification')) {
    return;
  }

  class ScrollToSpecification extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.attachEvents();
    }

    attachEvents() {
      this.addEventListener('click', this.openSpecification.bind(this));
    }

    openSpecification(event) {
      const element = document.querySelector(this.dataset.elementId);

      if (!element) {
        return;
      }

      element.querySelector('summary')?.click();

      event.preventDefault();
    }
  }

  customElements.define('scroll-to-specification', ScrollToSpecification);
})();
